import { h } from 'vue';
import VueSelect from 'vue-select';

// Обёртка над vue-select: задаёт русский текст «нет совпадений» по умолчанию
// во всех селектах приложения. Если родитель передаёт свой слот #no-options,
// он переопределяет дефолт. Все пропсы, события и остальные слоты пробрасываются как есть.
export default {
  name: 'VSelectRu',
  inheritAttrs: false,
  setup(_, { attrs, slots }) {
    return () => h(VueSelect, attrs, {
      'no-options': () => 'Ничего не найдено',
      ...slots,
    });
  },
};
